import { headerBreak } from '@/components/content/Header/styles/break';
import { SxProps, Theme } from '@mui/material';

type StickyProductHeaderType = {
	productBar: ({
		isProductBarVisible,
		bottomNavigationHeight,
	}: {
		isProductBarVisible: boolean;
		bottomNavigationHeight: number;
	}) => SxProps<Theme>;
	navigationBar: ({
		isProductBarVisible,
		isNavigationBarVisible,
		productBarHeight,
		headerHeight,
	}: {
		isNavigationBarVisible: boolean;
		isProductBarVisible: boolean;
		productBarHeight: number;
		headerHeight: number;
	}) => SxProps<Theme>;
};

export const stickyProductHeaderSX: StickyProductHeaderType = {
	productBar: ({
		isProductBarVisible,
		bottomNavigationHeight,
	}: {
		isProductBarVisible: boolean;
		bottomNavigationHeight: number;
	}) => ({
		pointerEvents: isProductBarVisible ? 'auto' : 'none',
		opacity: isProductBarVisible ? 1 : 0,
		transform: headerBreak({
			mobile: isProductBarVisible
				? `translateY(-${bottomNavigationHeight}px)`
				: `translateY(calc(100% - ${bottomNavigationHeight}px))`,
			desktop: isProductBarVisible ? 'translateY(0)' : 'translateY(-100%)',
		}),
		bottom: headerBreak({
			mobile: '0px',
			desktop: 'unset',
		}),
		top: headerBreak({
			mobile: 'unset',
			desktop: '0px',
		}),
	}),
	navigationBar: ({
		isNavigationBarVisible,
		isProductBarVisible,
		productBarHeight,
		headerHeight,
	}: {
		isNavigationBarVisible: boolean;
		isProductBarVisible: boolean;
		productBarHeight: number;
		headerHeight: number;
	}) => ({
		pointerEvents: isNavigationBarVisible ? 'auto' : 'none',
		opacity: isNavigationBarVisible ? 1 : 0,
		transform: headerBreak({
			mobile: isNavigationBarVisible
				? `translateY(${headerHeight - productBarHeight}px)`
				: `translateY(calc(-100% + ${headerHeight}px))`,
			desktop: isNavigationBarVisible
				? isProductBarVisible
					? `translateY(0)`
					: `translateY(-${productBarHeight}px)`
				: 'translateY(-100%)',
		}),
	}),
};
